import axios from "axios";
import router from "./../../router";
import store from "./../../store";
import httpUrl from "@/utils/httpUrl";
// import { Base64 } from "js-base64";
import { message, Modal } from "ant-design-vue";
import pubMsg from "@/utils/pubMsg";
import UtilsConfig from "@/utils/config";
import qs from "qs";
import storage from "@/utils/storage";
import { ACCESS_TOKEN } from "@/utils/mutation-types";

//默认超时时间
axios.defaults.timeout = 300 * 1000;
//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// 配置请求头
axios.defaults.headers.post["Content-Type"] = "application/json; charset=utf-8";
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // token
    const token = storage.get(ACCESS_TOKEN);
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  error => {
    console.log("错误的传参");
    return Promise.reject(error);
  }
);

// 响应拦截器
axios.interceptors.response.use(
  response => {
    const { config, data } = response;
    const { options } = config;
    const { code, message } = data;

    // 文件流类型的接口，是否直接返回，没有response的那种  默认不是文件流类型
    // console.log(response);
    if (config.responseType == "blob") {
      return response;
    }

    if (!data) {
      // return '[HTTP] Request has no return value';
      pubMsg.tipMessage(Promise.reject(data));
      return Promise.reject(data);
    }
    // 接口请求成功，直接返回结果
    if (code == UtilsConfig.pubCode) {
      return data;
    }

    // 登录超时 或者
    // token错误接口302的时候
    if (code == 401 || (config.url.indexOf("findByToken") > -1 && !data.id)) {
      console.log("登录超时");
      // 到登录页
      const timeoutMsg = "登录超时,请重新登录!";
      Modal.destroyAll();
      Modal.warning({
        title: "提示",
        content: "登录身份已失效,请重新登录!",
        onOk: () => {
          router.replace({
            path: "/login",
          });
          store.commit("setting/setMenu", []); // 全部路由存入
          store.commit("setting/setIsMenu", false); // 是否加载过路由
          storage.clear();
        },
      });
      return Promise.reject(new Error(timeoutMsg));
    }
    // 接口请求错误，统一提示错误信息
    if (code != UtilsConfig.pubCode) {
      const errMsg = message || "操作失败,系统异常!";
      // 是否在页面内处理错误信息，默认在公共地方处理错误信息，即错误弹窗是否在公共部分弹出来 返回一个空对象
      // console.log(options.showCodeInPage);
      if (options.showCodeInPage) {
        return data;
      } else {
        if (options.messageType == 1) {
          pubMsg.tipMessage(errMsg);
        } else if (options.messageType == 2) {
          pubMsg.alert(errMsg);
        } else if (options.messageType == 3) {
          pubMsg.tipNotification(errMsg);
        } else {
          requestMsg(errMsg);
        }
        // 错误弹窗在公共部分弹出来 返回一个空对象，页面要判断res.code
        return {};
      }
    }
    return data;
  },
  error => {
    console.log(error);
    // Do something with response error
    pubMsg.tipMessage(error.message);
    return {};
  }
);

const requestMsg = function(text) {
  message.warning(text || "服务器请求出现错误，请稍后再试~");
};
// const getKong = function(data) {
//   // 过滤掉空的参数
//   // text.replace(/^\s+|\s+$/g, "") 去除参数前后空格字符
//   let _newData = {};
//   for (var key in data) {
//     if (typeof data[key] == "string") {
//       _newData[key] = data[key].toString().replace(/^\s+|\s+$/g, "");
//     } else {
//       _newData[key] = data[key];
//     }
//   }
//   return _newData;
// };

// 基地址
const baseUrl = httpUrl.baseUrl;
// 通用方法
const commonApi = (config, options) => {
  // const newParams = params || {};
  const { url, method, params, data } = config;
  options = options || {};
  const httpDefault = {
    method: method,
    // 如果有指定的换IP的，则写在option里面
    baseURL: options.url ? `${options.url}/` : `${baseUrl.web}/`,
    // `params` 是即将与请求一起发送的 URL 参数
    // 这里不使用axios的params来传参，因为使用new promise之后，get参数会在第一个参数前加&(可能是因为axios版本太低?)，总感觉不爽，所以这里直接拼接URL
    // `data` 是作为请求主体被发送的数据
    // 有时候会有后台写post接口把一部分参数放在URL上，所以出现了第四个参数的情况
    url: params ? url + "?" + qs.stringify(params) : url,
    data: data || null,
    options: {
      // 是否在页面里处理返回数据 默认否; 为否时，在公共部分处理异常，接口返回null，页面接不到接口数据
      showCodeInPage: options.showCodeInPage ? true : false,
      // 如果使用公共错误弹窗  1中间message 2alert 3右上角notification
      messageType: options.messageType ? options.messageType : 1,
    },
  };
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      .then(response => {
        if (response) {
          resolve(response);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
};

// 读卡机读身份证信息
const readcardApi = (config, options = {}) => {
  const { url, method, params } = config;
  let httpDefault = {
    method: method,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PUT, DELETE",
      "Access-Control-Allow-Headers": "x-requested-with,content-type",
      "Reporting-Endpoints":
        "default='https://reporting-endpoint.glitch.me/post'",
    },
    // `params` 是即将与请求一起发送的 URL 参数
    // `data` 是作为请求主体被发送的数据
    data: qs.stringify(params),
    options: {
      // 是否在公共里弹出错误提示 默认是
      showCodeInPage: options.showCodeInPage ? false : true,
      // 如果使用公共错误弹窗  1右上角 2alert
      messageType: options.messageType ? options.messageType : 1,
      // 文件流类型的接口，是否直接返回，没有response的  默认不是文件流类型
      directReturn: options.directReturn ? true : false,
    },
  };
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        const errMsg = error || "请求失败!";
        requestMsg(errMsg);
        reject(errMsg);
      });
  });
};

// 验证码图片 文件流
const captchaApi = (config, options = {}) => {
  const { url, method, params } = config;
  let httpDefault = {
    method: method,
    baseURL: baseUrl.web,
    url: url,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    responseType: "blob", // 设置接收格式为blob格式
    // `params` 是即将与请求一起发送的 URL 参数
    // `data` 是作为请求主体被发送的数据
    data: qs.stringify(params),
    options: {
      // 是否在公共里弹出错误提示 默认是
      showCodeInPage: options.showCodeInPage ? false : true,
      // 如果使用公共错误弹窗  1右上角 2alert
      messageType: options.messageType ? options.messageType : 1,
      // 文件流类型的接口，是否直接返回，没有response的  默认不是文件流类型
      directReturn: options.directReturn ? true : false,
    },
  };
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        const errMsg = error || "请求失败!";
        requestMsg(errMsg);
        reject(errMsg);
      });
  });
};

// 上传文件
const uploadFiles = (url, params) => {
  const newParams = params || {};
  let httpDefault = {
    method: "POST",
    baseURL: baseUrl.web,
    url: url,
    data: newParams,
    options: {},
    headers: {
      "Content-Type": "multipart/form-data",
      Accept:
        "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
    },
  };
  return new Promise((resolve, reject) => {
    axios(httpDefault)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        requestMsg(error + "");
        reject(error);
      });
  });
};
const exportTable = (url, data, params) => {
  const newUrl = params
    ? baseUrl.web + url + "?" + qs.stringify(params)
    : baseUrl.web + url;
  return new Promise((resolve, reject) => {
    axios
      .post(newUrl, data, {
        responseType: "blob",
      })
      .then(response => {
        console.log(response);
        let resHeaders = response.headers["content-disposition"];
        console.log(resHeaders);
        if (resHeaders) {
          let blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          let objectUrl = URL.createObjectURL(blob); // 设置文件类型，这里以excel为例
          let fileName = decodeURIComponent(
            resHeaders.replace("attachment;filename=", "")
          );
          let a = document.createElement("a");
          a.href = objectUrl;
          a.target = "_blank";
          a.download = fileName;
          a.click();
          resolve({
            code: 200,
          });
        } else {
          requestMsg("导出失败");
          resolve(response.data);
        }
      })
      .catch(error => {
        requestMsg(error + "");
        reject(error);
      });
  });
};

// const GET = (base, url, params) => {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(`${base}${url}`, {
//         params: params,
//       })
//       .then(response => {
//         resolve(response.data);
//       })
//       .catch(error => {
//         requestMsg(error + "");
//         reject(error);
//       });
//   });
// };
export default {
  baseUrl,
  commonApi,
  readcardApi,
  captchaApi,
  uploadFiles,
  exportTable,
};
